import React from 'react';
import {Link} from 'react-router-dom';
import {Message, Transition} from 'semantic-ui-react';
import {AGB_PAGE_PATH} from '../legalPages';

const ConsentCheckbox = ({id, checked, onChange, children, className, 'data-cy': dataCy}) => (
    <div className={['ui', 'checkbox', className, checked ? 'checked' : ''].filter(Boolean).join(' ')}>
        <input
            id={id}
            type="checkbox"
            className="hidden"
            checked={checked}
            data-cy={dataCy}
            onChange={(ev) => onChange(ev.target.checked)}
        />
        <label htmlFor={id}>{children}</label>
    </div>
);

const AuthConsentCheckboxes = ({
    cookiesAgreed,
    agbAgreed,
    onCookiesChange,
    onAgbChange,
    shakeVisible,
}) => (
    <Transition animation="shake" visible={shakeVisible}>
        <Message size="mini" className="cuddle login-consent-message">
            <ConsentCheckbox
                id="login-consent-cookies"
                checked={cookiesAgreed}
                onChange={onCookiesChange}
                data-cy="terms-cookies"
            >
                Ich willige die Nutzung von Sitzungscookies ein, die für die Dauer einer
                Sitzung im Browser gespeichert werden.
            </ConsentCheckbox>
            <ConsentCheckbox
                id="login-consent-agb"
                className="login-consent-agb"
                checked={agbAgreed}
                onChange={onAgbChange}
                data-cy="terms-agb"
            >
                <span className="login-consent-agb-label">
                    Ich erkläre mich mit den{' '}
                    <Link
                        to={AGB_PAGE_PATH}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="login-agb-link-word"
                        data-cy="agb-link"
                        onClick={(ev) => ev.stopPropagation()}
                    >
                        AGB
                    </Link>
                    {' '}
                    einverstanden und bestätige, dass ich mindestens 18 Jahre alt bin.
                </span>
            </ConsentCheckbox>
        </Message>
    </Transition>
);

export default AuthConsentCheckboxes;
